/**
 * get params form url
 */
export default function getParam(name) {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]')
  var regex = new RegExp('[\\?&]' + name + '=([^&#]*)')
  var results = regex.exec(location.search)
  if (results) {
    return results[1]
  } else {
    return null
  }
}



// WEBPACK FOOTER //
// ./scripts/util/getURLParam.js